import { render } from "./CategoryList.vue?vue&type=template&id=196f7e72&scoped=true"
import script from "./CategoryList.vue?vue&type=script&lang=js"
export * from "./CategoryList.vue?vue&type=script&lang=js"

import "./CategoryList.vue?vue&type=style&index=0&id=196f7e72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196f7e72"]])

export default __exports__